export const DEFAULT_RECORD_COUNT = 5;
export const DEFAULT_ROW_PER_PAGE = 10;
export const DEFAULT_LENGTH = 4;
export const MAX_LENGTH_FOR_ZIP_API_CALL = 5;
export const MIN_LENGTH_FOR_ZIP_CLEAR = 0;
